import { useState } from "react";

import { AC_STEP_CONFIRM_AGE, AC_STEP_USER_INFO } from "../../utils/AccountCreationConstants";

import useAccountCreationData from "../../../../../../state/landingPages/accountCreation/UseAccountCreationData";

const INITIAL_VERIFICATION_ERROR_POPUP_STATE = {
  displayPopup: false,
  errorMessage: ''
};

const useAccountCreationParentPhoneNumber = () => {
  const { accountCreationState, parentVerificationState, updateAccountCreationStep, updateAccountCreationPageData, postParentVerification } = useAccountCreationData();
  const [verificationErrorPopupState, setVerificationErrorPopupState] = useState(INITIAL_VERIFICATION_ERROR_POPUP_STATE);

  const onBackClicked = () => {
    updateAccountCreationStep(AC_STEP_CONFIRM_AGE);
  };

  const onCloseVerificationErrorPopupClicked = () => {
    setVerificationErrorPopupState(INITIAL_VERIFICATION_ERROR_POPUP_STATE);
  };

  const onSubmitFormCallback = (formState) => {
    // Call parent verification API
    const postParentVerificationPromise = postParentVerification(formState.parentPhone);

    if (postParentVerificationPromise ?? false) {
      postParentVerificationPromise.then((newState) => {
        if (newState ?? false) {
          console.log('Parent verification response:', newState);
          if (newState.objData && newState.objData.parentVerificationId > 0) {
            // Store parent phone number in userInfo so it can be passed to CreateStep1
            const currentUserInfo = accountCreationState.userInfoData || {};
            const updatedUserInfo = {
              ...currentUserInfo,
              phoneNumber: formState.parentPhone,
              parentVerificationId: newState.objData.parentVerificationId
            };
            
            // Save parent verification ID and phone in parentVerificationData for backward compatibility
            const parentVerificationData = {
              parentVerificationId: newState.objData.parentVerificationId,
              parentPhone: formState.parentPhone
            };
            console.log('Storing parentVerificationData:', parentVerificationData);

            // Save parent phone in parentPhoneData for backward compatibility
            const parentPhoneData = {
              parentPhone: formState.parentPhone
            };
            
            // Update account creation state with all the data
            updateAccountCreationPageData(updatedUserInfo, 'userInfoData');
            //updateAccountCreationPageData(parentVerificationData, 'parentVerificationData');
            //updateAccountCreationPageData(parentPhoneData, 'parentPhoneData');
            
            // Navigate to next step
            updateAccountCreationStep(AC_STEP_USER_INFO, parentVerificationData, 'parentVerificationData');
          } else {
            setVerificationErrorPopupState({
              displayPopup: true,
              errorMessage: newState.objData.errorMessage || 'Failed to verify parent phone number. Please try again.'
            });
          }
        }
      }).catch((e) => {
        setVerificationErrorPopupState({
          displayPopup: true,
          errorMessage: e?.message || 'An error occurred while verifying the parent phone number.'
        });
      });
    } else {
      setVerificationErrorPopupState({
        displayPopup: true,
        errorMessage: 'Unable to initiate parent verification. Please try again.'
      });
    }
  };

  return {
    parentPhoneData: accountCreationState?.parentPhoneData || {},
    isLoading: parentVerificationState.isObjLoading,
    verificationErrorPopupState,
    onBackClicked,
    onCloseVerificationErrorPopupClicked,
    onSubmitFormCallback
  };
};

export default useAccountCreationParentPhoneNumber;